import React, { Fragment } from 'react'
import {
  StyleAddSubAdminMessage,
  StyleAddSubAdminMessageWrapper,
  StyleAddSubAdminTitle,
} from './style'
import Svg from '@components/svg'
import { bulb } from '@assets/icons'
import Column from '@components/column'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Button from '@components/button'
import { Admin } from '@apis/index'
import { useModal } from '@context/ModalContext'

const AddSubAdmin = () => {
  const { hideModal } = useModal()
  const initialValues = {
    fullName: '',
    email: '',
    number: '',
    password: '',
    permission: [],
    allowLoadWallet: '',
  }

  const handleSubmit = async (values: typeof initialValues) => {
    const payload = {
      name: values.fullName,
      username: values.email.split('@')[0],
      email: values.email,
      password: values.password || generateRandomPassword(),
      permissions: values.permission,
      allowLoadWallet: values.allowLoadWallet || false,
    }
    await Admin.create({ data: JSON.stringify(payload), state: 'subadmin' })
      .then(() => hideModal())
      .catch()
  }

  const generateRandomPassword = () => {
    return Math.random().toString(36).slice(-8)
  }

  return (
    <Fragment>
      <Column>
        <StyleAddSubAdminTitle>Add Sub Admin</StyleAddSubAdminTitle>
        <StyleAddSubAdminMessageWrapper>
          <Svg src={bulb} />
          <StyleAddSubAdminMessage>
            System will generate Password and Send to Email if kept Empty
          </StyleAddSubAdminMessage>
        </StyleAddSubAdminMessageWrapper>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          <Form>
            <Column>
              <Fields.Input
                name="fullName"
                placeholder="Enter Full Name"
                label="Full Name"
              />
              <Fields.Input
                name="email"
                placeholder="Enter Email"
                label="Email"
              />
              <Fields.Input
                name="number"
                placeholder="Enter Mobile Number"
                label="Mobile Number"
              />

              <Fields.GroupCheckBox
                name="permission"
                label="Permission Module"
                options={[
                  { label: 'Game Module', key: 'games' },
                  { label: 'Store Module', key: 'stores' },
                  { label: 'Ticket Module', key: 'tickets' },
                  { label: 'Payment Module', key: 'payments' },
                  { label: 'Dashboard', key: 'dashboard' },
                  { label: 'Users', key: 'users' },
                  { label: 'Banners', key: 'banners' },
                  { label: 'Settings', key: 'settings' },
                  { label: 'Notifications', key: 'notifications' },
                ]}
                titleAsKey="label"
                valueAsKey="key"
              />
              <Fields.Switch
                name="allowLoadWallet"
                label="Allow this User to Load Wallet"
              />
              <Fields.Password
                name="password"
                label="Set Password"
                placeholder="Enter Password"
              />
            </Column>
            <br />
            <br />
            <Button title="Add Admin" width={100} height={45} type="submit" />
          </Form>
        </Formik>
      </Column>
    </Fragment>
  )
}

export default AddSubAdmin
